/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMilestoneNotificationActionData
 */
export interface UserMilestoneNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof UserMilestoneNotificationActionData
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof UserMilestoneNotificationActionData
     */
    threshold: number;
    /**
     * 
     * @type {string}
     * @memberof UserMilestoneNotificationActionData
     */
    userId: string;
}

/**
 * Check if a given object implements the UserMilestoneNotificationActionData interface.
 */
export function instanceOfUserMilestoneNotificationActionData(value: object): value is UserMilestoneNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "threshold" in value && value["threshold"] !== undefined;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;

    return isInstance;
}

export function UserMilestoneNotificationActionDataFromJSON(json: any): UserMilestoneNotificationActionData {
    return UserMilestoneNotificationActionDataFromJSONTyped(json, false);
}

export function UserMilestoneNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMilestoneNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'threshold': json['threshold'],
        'userId': json['user_id'],
    };
}

export function UserMilestoneNotificationActionDataToJSON(value?: UserMilestoneNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'threshold': value.threshold,
        'user_id': value.userId,
    };
}

